import User from './user'

export default class Target {
  readonly id: number
  readonly userId: number
  readonly examId: number
  readonly commentableId: number
  readonly commentableType: string
  readonly body: string
  readonly questionId: number
  readonly inquiryId: number
  readonly user: User

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.userId = data.userId
    this.examId = data.examId
    this.commentableId = data.commentableId
    this.commentableType = data.commentableType
    this.body = data.body
    this.questionId = data.questionId
    this.inquiryId = data.inquiryId

    if (data.user) {
      this.user = new User(data.user)
    }
  }
}
